import { createApi } from '@reduxjs/toolkit/query/react';
import { createExtendedTokenBaseQuery } from '@/store/api/baseQuery';

interface UUIDResolverResponse {
  success: boolean;
  data: Record<string, any>;
  resolved_count: number;
  total_uuids_found: number;
  message: string;
}

export const uuidResolverApi = createApi({
  reducerPath: 'uuidResolverApi',
  baseQuery: createExtendedTokenBaseQuery('workflows/'),
  endpoints: (builder) => ({
    resolveUUIDs: builder.mutation<UUIDResolverResponse, Record<string, any>>({
      query: (data) => ({
        url: 'uuid-resolver/',
        method: 'POST',
        body: { data },
      }),
    }),
    getResolverInfo: builder.query<{ supported_fields: string[]; field_mappings: Record<string, any> }, void>({
      query: () => 'uuid-resolver/info/',
    }),
  }),
});

export const { useResolveUUIDsMutation, useGetResolverInfoQuery } = uuidResolverApi;
